import ShaderBase from "./_shaderBase.js";
import { fieldUniforms } from "./shader-chunks.js";
export default class Starfield extends ShaderBase {}
Starfield.prototype.defaultOptions = {
  color: 0xcdeafa,
  color2: 0x967bfa,
  backgroundColor: 0x030712,
};
Starfield.prototype.fragmentShader =
  fieldUniforms +
  `
void main(){vec2 uv=(gl_FragCoord.xy-.5*iResolution)/iResolution.y;vec2 mouse=iMouse/iResolution-.5;vec3 c=backgroundColor;
for(int layer=0;layer<5;layer++){float l=float(layer),z=fract(l/5.+iTime*.025);float scale=mix(38.,4.,z);vec2 p=(uv+mouse*z*.12)*scale+vec2(l*17.,l*9.);vec2 cell=floor(p),f=fract(p);float h=hash(cell+l);vec2 center=vec2(hash(cell+3.),hash(cell+7.));float d=length(f-center);float star=exp(-d*d*480.)*step(.86,h);float fade=sin(z*3.14159);c+=mix(color,color2,h)*star*fade*intensity*1.4*(.7+.3*sin(iTime+h*30.));}
gl_FragColor=vec4(c,1.);}`;
